import { render, staticRenderFns } from "./LoaderComponent.vue?vue&type=template&id=830b37d4&"
import script from "./LoaderComponent.vue?vue&type=script&lang=js&"
export * from "./LoaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoaderComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports